import type { Suggestion } from "@nlc/shared-types";
import type React from "react";

import {
  Dialog,
  DialogBody,
  DialogCloseButton,
  DialogHeader,
  DialogTitle,
} from "@/components/dialog";
import { Modal } from "@/components/modal";

import { SuggestionCard } from "./SuggestionCard";

interface SuggestionModalProps {
  isOpen: boolean;
  onOpenChange: React.Dispatch<React.SetStateAction<boolean>>;
  subtitle?: string;
  suggestions: Suggestion[];
  title?: string;
}

export function SuggestionModal({
  isOpen,
  onOpenChange,
  subtitle = "We have some suggestions to keep you moving forward.",
  suggestions,
  title = "Meta Ads request completed!",
}: SuggestionModalProps) {
  return (
    <Modal
      classNames={{
        modal:
          "w-full max-w-[672px]  overflow-y-auto mx-3xl rounded-md my-auto",
      }}
      isDismissable
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      <Dialog>
        <DialogHeader>
          <DialogTitle className="text-text-primary text-3xl md:text-4xl font-semibold">
            {title}
          </DialogTitle>
          <span className="text-text-primary text-sm font-normal">
            {subtitle}
          </span>
        </DialogHeader>
        <DialogCloseButton />
        <DialogBody className="flex md:flex-row gap-xl pb-3xl">
          {suggestions.map((suggestion) => (
            <SuggestionCard
              data={suggestion}
              key={`${suggestion.designTypeId}-${suggestion.description}`}
            />
          ))}
        </DialogBody>
      </Dialog>
    </Modal>
  );
}

// Export the Suggestion type for consumers
export type { Suggestion } from "@nlc/shared-types";
